// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"0c77d302","6803":"143848ab","8196":"47304c11"}[chunkId] + ".chunk.css";
};